import { render, staticRenderFns } from "./sms-test-card.vue?vue&type=template&id=68a189de&scoped=true"
import script from "./sms-test-card.vue?vue&type=script&lang=ts"
export * from "./sms-test-card.vue?vue&type=script&lang=ts"
import style0 from "./sms-test-card.vue?vue&type=style&index=0&id=68a189de&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a189de",
  null
  
)

export default component.exports